/**
 * Field display rules from admin's onboarding field contract (ENG-2535).
 *
 * A field may carry `visible_when: { <other field>: [allowed values] }`: it
 * shows only while every named field's current value is one of its allowed
 * values. Visibility is display only: a hidden field keeps its value and is
 * still submitted as-is (never cleared or sent blank). Fields without a rule
 * always show.
 */
export type VisibleWhen = Record<string, unknown[]>;

/** Compare values as strings; null/undefined (and the site page's
 * stringified "null"/"undefined") read as "". */
export const normalizeFieldValue = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  const text = String(value);
  return text === "null" || text === "undefined" ? "" : text;
};

export const isFieldVisible = (
  rule: VisibleWhen | null | undefined,
  values: object | null | undefined
): boolean => {
  if (!rule || typeof rule !== "object") return true;
  const current = (values ?? {}) as Record<string, unknown>;
  return Object.entries(rule).every(([name, allowed]) => {
    if (!Array.isArray(allowed)) return true;
    const value = normalizeFieldValue(current[name]);
    return allowed.some((option) => normalizeFieldValue(option) === value);
  });
};
